<template>
  <div class="app-container">
    <!--    <el-card class="mb20 mt20 ml20 mr20 ta-l">-->
    <!--      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true"></el-form>-->
    <!--    </el-card>-->

    <el-card class="mb20 mt20 ml20 mr20 ta-l">
      <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :height="getDynamicStyles(false)">
        <el-table-column
            prop="productName"
            label="商品名称"
            align="center">
        </el-table-column>
        <el-table-column
            align="center"
            prop="tradeNo"
            label="订单编号"
            width="180">
        </el-table-column>
        <el-table-column
            align="center"
            prop="productPrice"
            label="商品价格"
        >
        </el-table-column>
        <el-table-column
            align="center"
            label="发票状态">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.invoiceStatus == 0" size="small">未申请</el-tag>
            <el-tag v-if="scope.row.invoiceStatus == 1" size="small">申请中</el-tag>
            <el-tag type="success" v-if="scope.row.invoiceStatus == 2" size="small">已开票</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="操作"
            width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleSubmit(scope.row.tradeNo)"
                       v-if="scope.row.invoiceStatus == '1'">开 票
            </el-button>

            <el-button size="mini" type="text" @click="handleCheck(scope.row.tradeNo)">查 看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container" ref="pagination">
        <pagination
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getInvoiceOrderList"
        />
      </div>
    </el-card>

    <invoice-upload
        v-if="visible"
        :visible.sync="visible"
        :tradeNo="tradeNo"
        @refresh="getInvoiceOrderList"
    />

    <invoice-header
        v-if="headerVisible"
        :visible.sync="headerVisible"
        :tradeNo="tradeNo"
    />

  </div>
</template>

<script>

import InvoiceUpload from "@/pages/customerEnterprise/components/invoiceUpload.vue";
import InvoiceHeader from "@/pages/customerEnterprise/components/invoiceHeader.vue";
import {getDynamicStyles} from "@/utils/ruoyi";

export default {
  name: "invoiceOrderList",
  components: {InvoiceHeader, InvoiceUpload},
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      tableData: [],
      loading: false,
      total: 0,

      visible: false,
      headerVisible: false,
      tradeNo: ''
    }
  },
  created() {
    this.getInvoiceOrderList()
  },
  methods: {
    getDynamicStyles,
    handleCheck(tradeNo) {
      this.tradeNo = tradeNo
      this.headerVisible = true
    },
    handleSubmit(tradeNo) {
      this.tradeNo = tradeNo
      this.visible = true
    },
    getInvoiceOrderList() {
      this.loading = true
      this.$http.get(this.$api.customerEnterprise.getInvoiceOrderList, this.queryParams).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.rows
          this.total = res.data.total
          this.loading = false;
        } else {
          this.$message.error(res.data.msg);
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">

</style>
